import { createGlobalStyle } from 'styled-components';

import 'normalize.css';

/**
 * Global Lumos styles.
 */
const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
  }
  a {
    color: ${({ theme }) => theme.colors.state.active};
    text-decoration: none;
    &:hover, :active {
      text-decoration: underline;
    }
  }

  fieldset {
    padding: 0;
    margin: 0;
    border: none;
    ${({ theme }) => `
      margin-bottom: ${theme.space[5]}px;
    `}
    font-family:  ${({ theme }) => `${theme.fonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;`}
  }

  code {
    ${({ theme }) => `
      border-radius: 4px;
      color: ${theme.colors.grayScale[10]};
      padding: ${theme.space[2]}px;
    `}
      margin: 0px;
      font-style: normal;
    }

  /* Modal styles */
  .lumos-modal {
    position: absolute;
    background-color: white;
    width: 343px;
    min-height: 205px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    ${({ theme }) => `
      border-radius: ${theme.radii[1]}px;
      @media screen and (min-width: ${theme.breakpoints.sm}) {
        width: 500px;
      }
    `}
  }
  .lumos-modal-overlay {
    ${({ theme }) => `
      z-index: ${theme.zIndices[4]};
    `}
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: rgba(99, 99, 99, 0.75);

    & > .lumos-modal {
      position: absolute;
      min-height: 205px;
      top: 50%;
      left: 50%;
      bottom: auto;
      transform: translate(-50%, -50%);
    }
  }

 /* Table styles */
 .ReactTable > .rt-table > .rt-thead .rt-tr {
  text-align: left;
}

.ReactTable .rt-resizer:before {
  display: inline-block;
  position: absolute;
  right: 44px;
  top: 2px;
  height: 18px;
  width: 18px;
  color: transparent;
  content: '.';
  background-size: 10px 18px;
  background-repeat: no-repeat;
  opacity: 0.87;
}

.ReactTable  .rt-resizable-header-content:after {
  position: absolute;
  right: 50px;
  top: 2px;
  height: 18px;
  width: 18px;
  z-index: 120;
  color: transparent;
  content: '.';
}

.ReactTable .rt-th.-sort-asc .rt-resizer:before {
  background-image: url(data:image/svg+xml;base64,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);
}

.ReactTable .rt-th.-sort-desc .rt-resizer:before {
  background-image: url(data:image/svg+xml;base64,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);
}
`;

export default GlobalStyles;

export const styledCardItem = () => `
  cursor: pointer;
  border-radius: 10px !important;
  &:hover {
    border-color: transparent;
    box-shadow: 0 1px 2px -2px rgba(0,0,0,0.16), 0 3px 6px 0 rgba(0,0,0,0.12), 0 5px 12px 4px rgba(0,0,0,0.09);
  }
`;

export const styledMaxLines = (line: number = 1) => `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${line};
  -webkit-box-orient: vertical;
`;
